import {
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
  IconButton,
  Button,
} from '@mui/material'
import { makeStyles } from '@material-ui/styles'
import { Add, Search, Edit, Visibility, Print } from '@mui/icons-material'

import useTable from '../UI/Table'

import { useState } from 'react'
import ClientesForm from './form'
import { useClients } from '../../services/clients'
import { CustomDialog } from '../UI/Dialog'
import { ClientDetails } from './details'
import Controls from '../UI/Controls'
import { generateTicketDelivery } from '../../services/reports'

const headCells = [
  { id: 'nc', label: 'ID' },
  { id: 'nombre', label: 'Nombre' },
  { id: 'domicilio', label: 'Domicilio' },
  { id: 'poblacion', label: 'Población' },
  { id: 'municipio', label: 'Municipio' },
  { id: 'telefono', label: 'Telefono' },
  { id: 'acciones', label: 'Acciones' },
]

const useStyles = makeStyles(() => ({
  searchInput: {
    width: '100%',
  },
  buttonAdd: {
    left: '5px',
    backgroundColor: '#dec65e',
  },
  tableCell: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0',
  },
  '@media (max-width: 750px)': {
    buttonAdd: {
      left: '5px',
      backgroundColor: '#dec65e',
    },
  },

  toolBar: {
    justifyContent: 'space-between',
  },
  '@media (max-width: 700px)': {
    toolBar: {
      display: 'list-item',
      flexWrap: 'wrap',
    },
    margin: {
      marginTop: '20px',
    },
  },
}))

export const Clients = () => {
  const [clients] = useClients()

  const classes = useStyles()

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items
    },
  })

  const { TblContainer, TblHead, TblPagination, recordAfterPagingAndSorting } =
    useTable(clients, headCells, filterFn)

  const [open, setOpen] = useState(false)
  const [openDetails, setOpenDetails] = useState(false)
  const [update, setUpdate] = useState({})
  const [details, setDetails] = useState({})
  const [flag, setFlag] = useState(false)

  const handleSearch = ({ target }) => {
    const { value } = target
    setFilterFn({
      fn: (items) => {
        if (target.value === '') return items
        else
          return items.filter((x) =>
            x.nombre.toLowerCase().includes(value.toLowerCase())
          )
      },
    })
  }

  const handlePrint = (client) => {
    const data = {
      cliente: client.nombre,
      lugar: client.calle + ' #' + client.numero + ', ' + client.colonia,
      referencia: client.referencia + ' TELEFONO: ' + client.telefono,
      localidad: client.poblacion + ', ' + client.municipio,
    }

    generateTicketDelivery(data)
  }

  return (
    <>
      <div style={{ marginTop: '3%' }} className="with-navbar">
        <h2 className="h1">Administración de Clientes</h2>
      </div>
      <div className="form" style={{ marginTop: '15px', marginBottom: '30px' }}>
        <Toolbar className={classes.toolBar}>
          <div
            className="medium-group"
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Controls.Input
              variant="standard"
              className={classes.searchInput}
              placeholder="Buscar Cliente"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                disableUnderline: true,
              }}
              onChange={handleSearch}
            />
          </div>
          <div
            className="medium-group"
            style={{ display: 'flex', justifyContent: 'end' }}
          >
            <Button
              variant="contained"
              startIcon={<Add />}
              sx={{
                backgroundColor: '#009696',
                padding: '12px 15px',
                height: '40px',
                fontSize: '1em;',
                border: '1px solid #00544e',
                borderRadius: '30px',
                transition: '0.3s all ease',
                color: 'secondary',
                '&:hover': {
                  backgroundColor: '#00544e',
                  border: '1px solid #009696',
                },
                '@media (max-width: 514px)': {
                  marginTop: '20px',
                },
              }}
              onClick={() => {
                setOpen(true)
                setUpdate({})
                setFlag(false)
              }}
            >
              Agregar
            </Button>
          </div>
        </Toolbar>
        <TblContainer>
          <TblHead />
          <TableBody>
            {recordAfterPagingAndSorting().map((client) => (
              <TableRow key={client.id}>
                <TableCell
                  data-label="Id: "
                  style={{ fontSize: '14px', fontFamily: 'Nunito' }}
                >
                  {client.nc}
                </TableCell>
                <TableCell
                  data-label="Nombre: "
                  style={{ fontSize: '14px', fontFamily: 'Nunito' }}
                >
                  {client.nombre}
                </TableCell>
                <TableCell
                  data-label="Domicilio: "
                  style={{ fontSize: '14px', fontFamily: 'Nunito' }}
                >
                  {client.calle + ' #' + client.numero + ', ' + client.colonia}
                </TableCell>
                <TableCell
                  data-label="Población: "
                  style={{ fontSize: '14px', fontFamily: 'Nunito' }}
                >
                  {client.poblacion}
                </TableCell>
                <TableCell
                  data-label="Municipio: "
                  style={{ fontSize: '14px', fontFamily: 'Nunito' }}
                >
                  {client.municipio}
                </TableCell>
                <TableCell
                  data-label="Telefono: "
                  style={{ fontSize: '14px', fontFamily: 'Nunito' }}
                >
                  {client.telefono}
                </TableCell>
                <TableCell
                  data-label="Acciones: "
                  style={{ fontSize: '14px', fontFamily: 'Nunito' }}
                >
                  <IconButton
                    onClick={() => {
                      setUpdate(client)
                      setFlag(true)
                      setOpen(true)
                    }}
                    sx={{
                      backgroundColor: 'orange',
                      color: 'white',
                      height: '30px',
                      width: '30px',
                      transition: '0.3s all ease',
                      marginRight: '5px',
                      '&:hover': {
                        backgroundColor: 'darkorange',
                        border: '1px solid orange',
                      },
                    }}
                  >
                    <Edit sx={{ width: '20px', height: '20px' }} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      setDetails(client)
                      setFlag(true)
                      setOpenDetails(true)
                    }}
                    sx={{
                      backgroundColor: '#00544e',
                      color: 'white',
                      height: '30px',
                      width: '30px',
                      transition: '0.3s all ease',
                      marginRight: '5px',
                      '&:hover': {
                        backgroundColor: '#009696',
                        border: '1px solid #00544e',
                      },
                    }}
                  >
                    <Visibility sx={{ width: '20px', height: '20px' }} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      handlePrint(client)
                    }}
                    sx={{
                      backgroundColor: '#00544e',
                      color: 'white',
                      height: '30px',
                      width: '30px',
                      transition: '0.3s all ease',
                      '&:hover': {
                        backgroundColor: '#009696',
                        border: '1px solid #00544e',
                      },
                    }}
                  >
                    <Print sx={{ width: '20px', height: '20px' }} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TblContainer>
        <TblPagination />
        <CustomDialog
          title="Formulario Clientes"
          openPopup={open}
          setOpenPopup={setOpen}
          maxWidth="md"
        >
          <ClientesForm
            setOpenPopup={setOpen}
            update={update}
            flag={flag}
            setFlag={setFlag}
            id={clients.length + 1}
          />
        </CustomDialog>
        <CustomDialog
          title="Información Clientes"
          openPopup={openDetails}
          setOpenPopup={setOpenDetails}
          maxWidth="md"
        >
          <ClientDetails setOpenPopup={setOpenDetails} details={details} />
        </CustomDialog>
      </div>
    </>
  )
}
